<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin: 20px;">
          <div style="margin: 40px;text-align: center;font-size: 18px;font-weight: bold;">制作打分表</div>
          <div style="display: flex;align-items: center;border-bottom: 1px solid lightgray;padding-bottom: 20px;">
            <div style="width:20%; font-size:16px;font-weight: bold;text-align: center;">打分表类别</div>
            <div style="width:60%; font-size:16px;font-weight: bold;text-align: center;">使用场景</div>
            <div style="width:20%; font-size:16px;font-weight: bold;text-align: center;">操作</div>
          </div>

          <div
            style="display: flex;align-items: center;margin-top: 20px;border-bottom: 1px solid lightgray;padding-bottom: 20px;"
            @click="selfScoreFormCreater">
            <div style="width:20%; font-size:16px;text-align: center;">简易自评(不带指标)</div>
            <div style="width:60%; font-size:16px;">实名打分。自评打分，无需定义指标，下发后直接打一个分收集上来导出Excel.</div>
            <div style="width:20%; font-size:16px;text-align: center;text-decoration: underline;cursor: pointer;font-weight: bold;">
              点我开始制作-></div>
          </div>

          <div @click="scoreFormCreater"
            style="display: flex;align-items: center;margin-top: 20px;border-bottom: 1px solid lightgray;padding-bottom: 20px;">
            <div style="width:20%; font-size:16px;text-align: center;">简易互评(不带指标)</div>
            <div style="width:60%; font-size:16px;">实名打分。互评打分，无需定义指标，下发后打分人给每个人打一个分数即可导出Excel。支持平级互评，上级对下级评价，下级对上级评价。</div>
            <div style="width:20%; font-size:16px;text-align: center;text-decoration: underline;cursor: pointer;font-weight: bold;">
              点我开始制作-></div>
          </div>

          <div @click="selfScoreFormCreaterEx"
            style="display: flex;align-items: center;margin-top: 20px;border-bottom: 1px solid lightgray;padding-bottom: 20px;">
            <div style="width:20%; font-size:16px;text-align: center;">高级自评(带指标)</div>
            <div style="width:60%; font-size:16px;">实名打分。自评打分，可定义指标，下发后每个人针对各个指标给自己打分，系统自动汇总后导出Excel.</div>
            <div style="width:20%; font-size:16px;text-align: center;text-decoration: underline;cursor: pointer;font-weight: bold;">
              点我开始制作-></div>
          </div>

          <div @click="scoreFormCreaterEx"
            style="display: flex;align-items: center;margin-top: 20px;border-bottom: 1px solid lightgray;padding-bottom: 20px;">
            <div style="width:20%; font-size:16px;text-align: center;">高级互评(带指标)</div>
            <div style="width:60%; font-size:16px;">
              实名打分。互评打分，可定义指标，下发后打分人按照指标分别给每个人打分，系统自动汇总后可导出Excel。支持平级互评，上级对下级评价，下级对上级评价。</div>
            <div style="width:20%; font-size:16px;text-align: center;text-decoration: underline;cursor: pointer;font-weight: bold;">
              点我开始制作-></div>
          </div>


          <div @click="satisfyFormCreater"
            style="display: flex;align-items: center;margin-top: 20px;border-bottom: 1px solid lightgray;padding-bottom: 20px;">
            <div style="width:20%; font-size:16px;text-align: center;">开放式单人表</div>
            <div style="width:60%; font-size:16px;">
              匿名打分。用于满意度，比赛观众现场打分等多种场景。没有确定的打分人，打分表一次只能给一个人打分，可设多个指标，打分人针对指标领表打分，评价结果导出Excel。</div>
            <div style="width:20%; font-size:16px;text-align: center;text-decoration: underline;cursor: pointer;font-weight: bold;">
              点我开始制作-></div>
          </div>

          <div @click="satisfyFormCreaterEx"
            style="display: flex;align-items: center;margin-top: 20px;border-bottom: 1px solid lightgray;padding-bottom: 20px;">
            <div style="width:20%; font-size:16px;text-align: center;">开放式多人表</div>
            <div style="width:60%; font-size:16px;">
              匿名打分。用于满意度，比赛观众现场打分等多种场景。没有确定的打分人，打分表一次可以给多个人打分，可设多个指标，打分人针对指标领表打分，评价结果导出Excel。</div>
            <div style="width:20%; font-size:16px;text-align: center;text-decoration: underline;cursor: pointer;font-weight: bold;">
              点我开始制作-></div>
          </div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {
      selfScoreFormCreater() {
        this.$router.push({
          name: 'self_score_form_creater',
          params: {}
        })
      },
      scoreFormCreater(){
        this.$router.push({
          name: 'score_form_creater',
          params: {}
        })
      },
      selfScoreFormCreaterEx() {
        this.$router.push({
          name: 'self_score_form_creater_ex',
          params: {}
        })
      },
      scoreFormCreaterEx(){
        this.$router.push({
          name: 'score_form_creater_ex',
          params: {}
        })
      },
      satisfyFormCreater(){
        this.$router.push({
          name: 'satisfy_form_creater',
          params: {}
        })
      },
      satisfyFormCreaterEx(){
        this.$router.push({
          name: 'satisfy_form_creater_ex',
          params: {}
        })
      }
    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/make_form_list.vue